<template>
	<vx-card class="stages-files">
		<div class="stages-files__title mb-3">
			<b>{{ $t('filesFromAuthor') }}</b>
		</div>
		<div class="stages-files__list">
			<div
				v-for="stage in validStages"
				:key="stage.index"
				class="stage"
			>
				<div class="stage__head flex justify-between items-center flex-wrap">
					<div class="stage__name">{{ $t('stage') }} {{ stage.index }}</div>
					<div
						v-if="currentStage !== null &stage.id === currentStage.id"
						class="stage__send"
					>
						<template>
							<vs-button
								v-if="!isSendClicked"
								@click="sendStageFiles(stage)"
								class="stage__send-btn"
								color="success"
							>{{ $t('send') }}</vs-button>

							<vs-button
								v-else
								disabled
								class="stage__send-btn"
								color="success"
							>{{ $t('send') }}</vs-button>
						</template>
					</div>
				</div>
				<div class="stage__files">
					<div
						v-for="(file, fileIndex) in stage.files"
						:key="fileIndex"
						class="stage__file"
					>
						<FileNameView
							:orderId="orderId"
							:url="file.url"
							:fileIndex="fileIndex"
							@fileDeleted="updateModel"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="stages-files__auto-sending">
			<vs-checkbox
				v-model="autoSending"
			>{{ $t('sendAutomatically') }}</vs-checkbox>
		</div> -->
	</vx-card>
</template>

<script>
import FileNameView from "@/views/Tickets/FileNameView";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "StagesFiles",
	mixins: [databaseManager, notifier],
	components: {
		FileNameView,
	},
	props: {
		orderId: { required: true, type: Number },
		stages: { required: true, type: Array },
		sending: { required: true, type: Boolean }
	},
	data() {
		return {
			isSendClicked: false
		}
	},
	watch: {
		autoSending() {
			this.setAutoSendFiles();
		}
	},
	computed: {
		autoSending: {
			get() {
				return this.sending;
			},
			set(value) {
				this.$emit("update:sending", value);
			}
		},
		validStages() {
			const handled = this.stages.map((item, index) => {
				return {
					id: item.id,
					index: index + 1,
					files: item.files,
				};
			});

			return handled.filter(item => item.files && item.files.length !== 0);
		},
		currentStage() {
			const current = this.stages.find(item => item.status !== 'completed');
			return current !== -1 ? current : null;
		},
	},
	methods: {
		async updateModel() {
			this.$emit('updateModel');
		},
		async setAutoSendFiles() {
			try {
				await this.dbSetAutoSendFiles(this.orderId, this.autoSending);

			} catch(e) {
				this.notifyError(e.message);
			}
		},
		async sendStageFiles(stage) {
			this.isSendClicked = true;

			try {
				await this.dbSendStageFiles(stage.id);
				this.notifySuccess(this.$t('filesWasSentToClient'));

			} catch(e) {
				this.notifyError(e.message);
			}

			this.isSendClicked = false;
		}
	}
}
</script>

<style lang="scss">
.stages-files {
	margin-top: 20px;

	&__list {
		.stage {
			padding-top: 15px;
			padding-bottom: 15px;
			border-top: #e4e4e4 1px solid;

			&:first-child {
				border-top: none;
				padding-top: 5px;
			}

			&__file {
				margin-top: 10px;
			}

			&__send-btn {
				padding: 7px 10px !important;
			}
		}
	}

	&__auto-sending {
		border-top: #e4e4e4 1px solid;
		padding-top: 15px;
	}
}
</style>
